module.exports = __webpack_public_path__ + "assets/e49301089a2b0f2d039c85ec7195f722.png";